import { Touchpoint } from '../../../../../../api/services/mediaPlanning/touchpoints';
import { CountryFormState } from '../../../../../../store/planStore';

const getMissingMandatoryTouchpoints = (
  countryForms: Record<string, Partial<CountryFormState>>
) => {
  const missingMandatoryTouchpoints = Object.entries(countryForms).reduce(
    (acc, [country, form]) => {
      const mandatoryTouchpoints =
        form.availableTouchpoints?.filter((tp) => tp.isMustHave === 1) || [];

      const digitalTouchpointsIncluded = new Set(
        (form.calculatedBudget ?? [])
          .map((b) => b?.touchpointName?.toUpperCase())
          .filter((name): name is string => Boolean(name))
      );

      const offlineTouchpointsIncluded = new Set(
        (form.offline?.tv?.offlineBudget ?? []).map((b) =>
          b.touchpoint.toUpperCase() === 'OUTDOOR'
            ? 'OOH'
            : b.touchpoint.toUpperCase()
        )
      );

      const allIncluded = new Set([
        ...Array.from(digitalTouchpointsIncluded),
        ...Array.from(offlineTouchpointsIncluded),
      ]);

      const missing = mandatoryTouchpoints.filter(
        (tp) => !allIncluded.has(tp.TouchpointName.toUpperCase())
      );

      if (missing.length > 0) {
        acc[country] = missing;
      }

      return acc;
    },
    {} as Record<string, Touchpoint[]>
  );

  return missingMandatoryTouchpoints;
};

export default getMissingMandatoryTouchpoints;
